import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { startEntityAdding } from '../../../entityManagement/actions';
import EntityManager from '../../../entityManagement/components/EntityManager';
import FloorAddForm from './FloorAddForm';
import FloorEditForm from './FloorEditForm';
import FloorsTable from './FloorsTable';
import FloorDeleteDialog from './FloorDeleteDialog';

const FloorsManager = EntityManager({
    Title: <LocalizedText textKey={TextKey.FloorPlural} />,
    Table: FloorsTable,
    AddForm: FloorAddForm,
    EditForm: FloorEditForm,
    DeleteDialog: FloorDeleteDialog,
});

export default connect(undefined, (dispatch, { scope }: { scope: string }) => ({
    onAdd: () => dispatch(startEntityAdding(scope)),
}))(FloorsManager);
